import { IUserNotification } from '@tableau/user-notifications-client-core';
import { Action } from 'redux';

import { GetUserNotifications, GetUserNotificationsFailed,GetUserNotificationsSucceeded } from '../../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../../bootstrap/redux/actions/isActionFactory';
import { GetUserNotificationsResult } from '../GetUserNotificationsResult';

export interface GetUserNotificationsAction extends Action {
  nextPageToken: string;
}

export interface GetUserNotificationsSucceededAction extends GetUserNotificationsAction {
  notifications: _.Dictionary<IUserNotification<any>>;
}

export interface GetUserNotificationsFailedAction extends Action { }

export function getUserNotificationsAction(nextPageToken: string): GetUserNotificationsAction {
  return {
    nextPageToken: nextPageToken,
    type: GetUserNotifications,
  };
}

export function getUserNotificationsSucceededAction(result: GetUserNotificationsResult): GetUserNotificationsSucceededAction {
  return {
    nextPageToken: result.nextPageToken,
    type: GetUserNotificationsSucceeded,
    notifications: result.notificationDict
  };
}

export function getUserNotificationsFailedAction(): GetUserNotificationsFailedAction {
  return {
    type: GetUserNotificationsFailed,
  };
}

export const isGetUserNotificationsAction = isActionFactory<GetUserNotificationsAction>(GetUserNotifications);

export const isGetUserNotificationsSucceededAction = isActionFactory<GetUserNotificationsSucceededAction>(GetUserNotificationsSucceeded);

export const isGetUserNotificationsFailedAction = isActionFactory<GetUserNotificationsFailedAction>(GetUserNotificationsFailed);